import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUsers, FaArrowRight } from "react-icons/fa";
import axios from "axios";
import Loader from "components/Loaders/Loader";
import "./styles/ManageUserCards.css";
import { useCheckSessionHeartBeat } from "components/API/ApiEnpoints";

const API_URL_ORGINFO = `${process.env.REACT_APP_API_URL}/api/org-info`;

interface OrgInfo {
  org_uid: string;
  active_user_count: number;
  inactive_user_count: number;
  admins: string[];
}

const ManageUserCards: React.FC = () => {
  useCheckSessionHeartBeat();
  const navigate = useNavigate();
  const [organizations, setOrganizations] = useState<OrgInfo[]>([]);
  const [loading, setLoading] = useState(true);

  const sessionUid = localStorage.getItem("session_uid") ?? "";
  const userUid = localStorage.getItem("user_uid") ?? "";
  const userPrivilege = localStorage.getItem("privilege");
  const SYSTEM_ADMIN_EMAIL = userUid;

  useEffect(() => {
    const fetchOrganizations = async () => {
      setLoading(true);
      try {
        const response = await axios.get(API_URL_ORGINFO, {
          headers: {
            Accept: "application/json",
            "user-uid": userUid,
          }, withCredentials: true,
        });
        if (response.status === 200) {
          setOrganizations(response.data.data);
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error fetching organizations:", error);
      } finally {
        setLoading(false); // Stop loading once done
      }
    };

    fetchOrganizations();
  }, []);

  // Filter organizations based on user role
  const filteredOrganizations =
    userUid === SYSTEM_ADMIN_EMAIL
      ? organizations // System admin sees all organizations
      : organizations.filter((org) => org.admins.includes(userUid)); // Org admin sees only their org

  return (
    <div className="manage-users-container">
      <h1 className="page-title">Manage Users</h1>

      {loading ? (
        <Loader /> // Display Loader while fetching data
      ) : (
        <div className="cards-container">
          {filteredOrganizations.length > 0 ? (
            filteredOrganizations.map((org) => {
              const totalUsers = org.active_user_count + org.inactive_user_count;

              return (
                <div key={org.org_uid} className="organization-card">
                  <div className="card-header">
                    <FaUsers className="icon" />
                    <div className="organization-details">
                      <h2 className="organization-name">{org.org_uid}</h2>
                      <p className="organization-email">
                        ADMIN: {org.admins.join(", ")}
                      </p>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="user-stats">
                      <p className="total-users">{totalUsers} Total users</p>
                      <p className="active-users">{org.active_user_count} Registered users</p>
                    </div>
                    <div className="button-group">
                      <button
                        className="view-users-button"
                        onClick={() =>
                          navigate(`/user-list?org=${org.org_uid}`, {
                            state: {
                              totalUsers,
                              activeUsers: org.active_user_count,
                              inactiveUsers: org.inactive_user_count,
                            },
                          })
                        }
                      >
                        View User <FaArrowRight />
                      </button>
                      {userPrivilege != "systemadmin" &&
                        <button
                          className="view-users-button"
                          onClick={() =>
                            navigate(`/user-status?org=${org.org_uid}`, {
                            })
                          }
                        >
                          User Status <FaArrowRight />
                        </button>
                      }
                    </div>
                  </div>
                  {/* <div className="card-footer">
                    <p className="last-updated">Last updated Time: N/A</p>
                    <p className="update-info">Last updated by: N/A</p>
                  </div> */}
                </div>
              );
            })
          ) : (
            <p>No organizations available.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ManageUserCards;
